/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Plan_Card_Select_PlanInputs */



/**
* | output |
* | --- |
* | "Select {plan} plan" |
*
* @param {Plan_Card_Select_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_card_select_plan = /** @type {((inputs: Plan_Card_Select_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Select_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.plan}-Plan auswählen`)
	return /** @type {LocalizedString} */ (`Select ${i?.plan} plan`)
});